<template>
    <SideFormSection :showDivider="true">
        <template #title>
            {{ entityWithAssociatedAvailability.getSectionTitle() }}
        </template>
        <template #rawContent>
            <Card
                :title="entityWithAssociatedAvailability.getSectionTitle()"
                iconName="calendar"
            >
                <template #content>
                    <ApiForm
                        method="POST"
                        :url="associateAvailabilityUrl"
                        ref="apiFormRef"
                    >
                        <FormControl label="Select an option">
                            <SelectInput
                                :value="
                                    entityWithAssociatedAvailability.getCurrentlyAssociatedAvailabilityId()
                                        ?.value
                                "
                                :name="
                                    entityWithAssociatedAvailability.getRequestBodyFieldName()
                                "
                            >
                                <option value="">None</option>
                                <template
                                    v-for="availability in availabilities"
                                    :key="availability.id.value"
                                >
                                    <option :value="availability.id.value">
                                        {{ availability.name }}
                                    </option>
                                </template>
                            </SelectInput>
                        </FormControl>
                    </ApiForm>
                </template>
                <template #actions>
                    <Button
                        @click="apiFormRef?.submit()"
                        :loading="apiFormRef?.loading.valueOf()"
                        iconName="save"
                    >
                        Save
                    </Button>
                </template>
            </Card>
        </template>
    </SideFormSection>
</template>

<script setup lang="ts">
    import { ref, type PropType } from 'vue'
    import SideFormSection from '@/Shared/Component/SideFormSection.vue'
    import Card from '@/Shared/Component/Card.vue'
    import Availability from '@/App/Availability/Entity/Availability'
    import SelectInput from '@/Shared/Component/Forms/SelectInput.vue'
    import Button from '@/Shared/Component/Button.vue'
    import ApiForm from '@/Shared/Component/Forms/ApiForm.vue'
    import type { ApiFormRefType } from '@/Shared/AutoGenerated/Types'
    import FormControl from '@/Shared/Component/Forms/FormControl.vue'
    import type EntityWithAssociatedAvailabilityInterface from '@/App/Availability/Entity/EntityWithAssociatedAvailabilityInterface'

    const props = defineProps({
        entityWithAssociatedAvailability: {
            type: Object as PropType<EntityWithAssociatedAvailabilityInterface>,
            required: true,
        },
        availabilities: {
            type: Array as PropType<Availability[]>,
            required: true,
        },
        associateAvailabilityUrl: {
            type: String,
            required: true,
        },
    })

    const apiFormRef = ref<ApiFormRefType>(null)
</script>
